<template>
    <div v-if="!disabled" >
    <button small v-if="!isTransmitting"
            class="aprocon-form--button aprocon-form--button-secondary" @click="transferItem">

        <v-icon small>ordermanager-input-output</v-icon>
        <span>Übertragen</span>

<!--        <v-icon small class="mr-2 white&#45;&#45;text">fa-upload</v-icon>-->

    </button>
    <upload-button v-else  :is-transmitting="isTransmitting" :light="true"/>
    </div>
<!--    <div v-else>-->
<!--        <v-menu top left>-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--                <button-->
<!--                    class="aprocon-form&#45;&#45;dropdown-item aprocon-table&#45;&#45;action-button-text mr-2"-->
<!--                    v-bind="attrs"-->
<!--                    v-on="on">-->
<!--                    <v-icon small>fa-ellipsis-vertical</v-icon>-->
<!--                </button>-->
<!--            </template>-->
<!--            <v-list>-->
<!--                <v-list-item @click="transferItem">-->
<!--                    <v-list-item-icon class="mr-2"><v-icon small>fa-upload</v-icon></v-list-item-icon>-->
<!--                    <v-list-item-title>Übertragen</v-list-item-title>-->
<!--                </v-list-item>-->
<!--            </v-list>-->
<!--        </v-menu>-->
<!--    </div>-->
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import UploadButton from "@/components/general/UploadButton.vue";
import {globalEventBus} from "@/main";
import {ScalesRestRepository} from "@/modules/scales/adapter/rest/ScalesRestRepository";

@Component({
    components: {UploadButton},
})
export default class TransferButton extends Vue {

    @Prop({default: false})
    private disabled!:boolean;
    private uploadIcon:string = require(`@/assets/icons/input-output-light.svg`);
    private isTransmitting:boolean=false;

    private async transferItem():Promise<void> {
        this.$emit("transferItem",{ isTransmitting: this.isTransmitting, title: "Waagen und Kassen"});
    }

}
</script>

<style scoped>

</style>
